import {
    BigJunctureStation,
    DecisionStation,
    InfoStation,
    SubZoneStation,
    TransitionStation,
    ZoneEndStation,
    ZoneStartStation
} from './MyMap/Map/components/ZoneMap/components/Station';

export enum StationType {
    ZoneStart = 'Zone Start',
    Decision = 'Decision',
    Info = 'Information',
    SubZone = 'Sub Zone',
    ZoneEnd = 'Zone End',
    Transition = 'Transition',
    BigJuncture = 'Big Juncture'
}

export type Legend = {
    type: StationType;
    label: string;
    altLabel?: string;
};

export type TimeRange = {
    weeks: {
        min: number;
        max: number;
    };
};

export type APIStationData = {
    id: string;
    name: string;
    description: string;
    type: StationType;
    xPosition: number;
    yPosition: number;
    time: TimeRange;
    zone?: Zone;
    stations?: APIStationData[];
    sectionID: string;
};

export type APIPathData = {
    start: {
        id: string;
        name?: string; //This field is only to support parsing map builder region
    };
    end: {
        id: string;
        name?: string; //This field is only to support parsing map builder region
    };
    description?: string;
    isLoopBack: boolean;
    isSelected: PathSelectionOptionValueType;
};

export type SectionData = {
    id: string;
    description: string;
    min: number;
};

export type APISectionData = {
    id: string;
    description: string;
};

export type Zone = {
    name: string;
    description?: string;
    stations: APIStationData[];
    paths: APIPathData[];
    sections?: APISectionData[];
    type?: ZoneType;
    isRemoved: boolean;
    ref?: {
        region: string;
        zone: ZoneType;
        regionId: string;
    };
};

export type ActivePosition = {
    zone: string;
    station: string;
};

type Map = {
    name: string;
};

type BasicZoneInfo = Pick<Zone, 'name' | 'description' | 'type' | 'isRemoved'>;

export const enum MapReleaseType {
    PUBLIC = 'Public'
}

export type MasterRegionBasicInfo = {
    id: string;
    version: string;
    name: string;
    displayName?: string;
    description: string;
    map: Map;
    zones: BasicZoneInfo[];
    updatedAt?: string;
    releaseType?: MapReleaseType;
};

export type Region = Omit<MasterRegionBasicInfo, 'zones'> & {
    position?: ActivePosition;
    zones: Zone[];
};

export const enum StationStatus {
    ACTIVE_STATION = 'active_station',
    TRAVELLED = 'travelled',
    NOT_TRAVELLED = 'not_travelled',
    DEFAULT = 'default',
    SELECTED = 'selected'
}

export type BaseStationData = {
    id: string;
    name: string;
    description: string;
    time: TimeRange;
    parentStation?: Station;
    xPosition: number;
    yPosition: number;
    sectionID: string;
    magnificationLevel?: number;
};

export type ZoneStartData = BaseStationData & {
    type: StationType.ZoneStart;
};

export type InfoStatoionData = BaseStationData & {
    type: StationType.Info;
};

export type DecisionStationData = BaseStationData & {
    type: StationType.Decision;
};

export type SubZoneData = BaseStationData & {
    type: StationType.SubZone;
    zone: Zone;
};

export type BigJunctureData = BaseStationData & {
    type: StationType.BigJuncture;
    stations: DecisionStationData[];
};

export type TransitionStationData = BaseStationData & {
    type: StationType.Transition;
};

export type ZoneEndData = BaseStationData & {
    type: StationType.ZoneEnd;
};

export type StationData =
    | ZoneStartData
    | InfoStatoionData
    | DecisionStationData
    | SubZoneData
    | BigJunctureData
    | TransitionStationData
    | ZoneEndData;

export type Station =
    | InfoStation
    | BigJunctureStation
    | DecisionStation
    | SubZoneStation
    | TransitionStation
    | ZoneEndStation
    | ZoneStartStation;

export type PathData = {
    source: Station;
    target: Station;
    description?: string;
    isLoopBack: boolean;
    isSelected: PathSelectionOptionValueType;
};

export type Position = {
    x: number;
    y: number;
};
export type PathSelectionOptionValueType = boolean | null;

export const enum PathType {
    LOOP_BACK = 'loop_back',
    SINGLE_CURVE = 'single_curve',
    DOUBLE_CURVE = 'double_curve',
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal'
}

export const enum ZoneType {
    DIAGNOSIS = 'DIAGNOSIS',
    TREATMENT = 'TREATMENT',
    SURVIVORSHIP = 'SURVIVORSHIP'
}

export type ExpandedStation = SubZoneStation | BigJunctureStation | undefined;
